/**
 * URL utilities for the Tank frontend.
 * Handles API base URL resolution and URL helpers.
 */

// API and Central storage base URLs
export const API_BASE =
  import.meta.env.VITE_OPERATOR_API || 'http://localhost:8000/api';
export const CENTRAL_BASE = API_BASE.replace(/\/api\/?$/, '/central');

// Operator base URL (without /api suffix) for non-API endpoints like /original/, /central/
// If API_BASE is relative (e.g., /api), we need the full origin for cross-origin requests
const rawOperatorBase = API_BASE.replace(/\/api\/?$/, '');
export const OPERATOR_BASE = rawOperatorBase || (typeof window !== 'undefined' ? window.location.origin : '');

/**
 * Resolve relative URLs to absolute URLs.
 * Handles /central/, /original/ paths and relative paths correctly.
 *
 * @param {string} url - URL to resolve (can be relative or absolute)
 * @returns {string} Resolved absolute URL
 */
export const resolveUrl = (url) => {
  if (!url) return '';
  // Already absolute
  if (/^https?:\/\//i.test(url)) return url;
  // If URL starts with operator-served paths, use operator base host
  if (url.startsWith('/central/') || url.startsWith('/original/')) {
    // If OPERATOR_BASE is empty or relative, use current origin
    if (!OPERATOR_BASE || OPERATOR_BASE.startsWith('/')) {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      return `${origin}${url}`;
    }
    return `${OPERATOR_BASE}${url}`;
  }
  const sep = url.startsWith('/') ? '' : '/';
  return `${CENTRAL_BASE}${sep}${url}`;
};

/**
 * Convert API response to array.
 * Handles both paginated responses with .results and direct arrays.
 *
 * @param {Object|Array} data - API response data
 * @returns {Array} Array of items
 */
export const toList = (data) => data?.results || data || [];
